<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mt-[13px] gap-x-[7px] gap-y-[12px]"
         :class="{ 'xl:grid-cols-4 2xl:grid-cols-6' : !isShorter, 'xl:grid-cols-2 2xl:grid-cols-4' : isShorter }"
         v-if="!loading && products.length > 0">
      <a href="javascript:void(0)" class="shadow-[0_0_12px_0_#D6E0E2] block rounded-[16px]" @click="openModal(each)"
         v-for="each in products" :key="each.id">
        <div class="overflow-hidden">
          <img :src="each.imageUrl" class="!w-full h-[119px] object-cover object-center rounded-t-2xl" width={216} height={119}
               loading="lazy"
               alt="product"/>
        </div>
        <div class="px-[18px] pt-[22px] pb-[10px] border-2 border-[#D6E0E2] border-t-0 -mt-[15px] rounded-b-[16px]">
          <div class="font-Bold text-[11px] text-[#798B97] truncate-to-1-line">
            {{ each.name_en }}
          </div>
          <hr class="w-full opacity-50 border-[#C6A798]"/>
          <div class="font-medium text-[10px] text-[#C6A798] mt-[5px] h-[30px] truncate-to-2-line">
            {{ each.description_en }}
          </div>
          <div class="flex items-center" :class="{ 'justify-end' : !each.gram, 'justify-between' : each.gram }">
            <div class="text-start text-[14px] font-bold text-[#C6A798]">
              <template v-if="each.gram"> {{ each.gram }} <sub> gr </sub></template>
            </div>
            <div class="text-end text-[14px] font-bold text-[#C6A798]">
              {{ each.price }} <sub> SAR </sub>
            </div>
          </div>
        </div>
      </a>
    </div>


    <template v-if="!loading && products.length == 0">
      <div class="flex items-center justify-center h-[120px] w-full">
        {{ lang === 'en' ? 'No products found' : 'لم يتم العثور على منتجات' }}.
      </div>
    </template>


    <template v-if="loading">
      <LoaderVue/>
    </template>
    <div class="fixed w-full h-full inset-0 z-50 flex justify-center items-center bg-black/45 duration-500"
         v-if="productModal" :class="{ 'visible' : productModal, 'invisible' : !productModal }">
      <div class="w-full max-w-[1050px] duration-500"
           :class="{'opacity-100 scale-100': productModal, 'opacity-0 scale-50' : !productModal}">
        <div class="p-5 lg:p-[33px] bg-[transparent]">
          <div class="bg-white p-6 lg:pt-[37px] lg:pb-[14px] rounded-[20px] w-full relative">
            <div class="absolute top-[-15px] end-[-15px] z-[99999999]">
              <button type="button"
                      class="border border-[#C1D5E5] flex justify-center items-center rounded-full outline-0 bg-white p-0 m-0 w-[44px] h-[44px]"
                      @click="closeModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.273" height="18.272" viewBox="0 0 18.273 18.272">
                  <path id="Path_2192" data-name="Path 2192"
                        d="M10.81,9.272l7.115-7.115A1.184,1.184,0,0,0,16.252.483L9.136,7.6,2.021.483A1.184,1.184,0,0,0,.347,2.157L7.462,9.272.347,16.388a1.184,1.184,0,1,0,1.674,1.674l7.115-7.115,7.115,7.115a1.184,1.184,0,1,0,1.674-1.674Zm0,0"
                        transform="translate(0 -0.136)" fill="#3e5463"/>
                </svg>
              </button>
            </div>
            <div class="w-full flex items-start flex-wrap" v-if="!optionLoading">
              <div class="w-full lg:w-1/2">
                <div class="relative overflow-hidden rounded-[20px]">
                  <img :src="product.imageUrl"
                       class="object-cover bg-cover object-center bg-center w-full min-h-[216px] max-h-[216px]"
                       loading="lazy"
                       alt="masala"/>
                  <div
                      class="absolute bottom-0 start-0 end-0 flex justify-between items-end px-[14px] pb-[11px] z-[999] h-[100px]"
                      :style="{ backgroundImage: 'url(/assets/images/background-gradient.png)' }">
                    <div class="rounded-[13px] w-[94px] p-0 m-0 h-[26px] !bg-[#E0E9F0] flex justify-center">
                      <div class="pt-[4px] text-[#635371] text-center">
                        {{product?.calories ?? 0}} kCal
                      </div>
                    </div>
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="32.082" height="26.701"
                           viewBox="0 0 32.082 26.701">
                        <g id="Group_490" data-name="Group 490" transform="translate(0 0)">
                          <g id="Group_396" data-name="Group 396" transform="translate(0 0)">
                            <path id="Path_2047" data-name="Path 2047"
                                  d="M29.5,2.616a8.959,8.959,0,0,0-12.655,0l-.811.81-.8-.81a8.958,8.958,0,0,0-12.654,0,9.05,9.05,0,0,0-.052,12.6c3.09,3.434,12.208,10.854,12.591,11.167a1.409,1.409,0,0,0,.893.317h.03a1.364,1.364,0,0,0,.923-.316c.391-.314,9.5-7.733,12.593-11.168a9.05,9.05,0,0,0-.055-12.6M27.448,13.323h0C25.042,16,18.418,21.52,16.041,23.48,13.66,21.521,7.038,16,4.628,13.324a6.251,6.251,0,0,1-.052-8.7,6.122,6.122,0,0,1,8.647,0L15.005,6.4a1.372,1.372,0,0,0,.76.383,1.42,1.42,0,0,0,1.3-.383L18.85,4.621a6.123,6.123,0,0,1,8.648,0,6.251,6.251,0,0,1-.051,8.7"
                                  transform="translate(0)" fill="#e0e9f0"/>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="uppercase text-[25px] font-medium text-[#798B97] mt-[11px] mb-[12px]">
                  {{ lang == 'en' ? product.name_en : product.name_ar }}
                </div>
                <div class="text-[15px] text-[#C6A798] mb-10 lg:mb-0">
                  {{ lang == 'en' ? product.description_en : product.description_ar }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 px-0 sm:px-[12px] pb-[4px] max-h-[500px] overflow-y-scroll scrollbar">
                <template v-if="productOptions.length > 0">
                  <template v-for="(each) in productOptions" :key="each.id">
                    <div
                        class="shadow-[0_0_8px_0_#E4ECF2] border border-[#E4ECF2] px-[12px] pb-[4px] rounded-[20px] mb-[7px]" v-if="each.option_type == 2">
                      <div class="text-[18px] sm:text-[20px] pt-[5px] font-medium">
                        {{ lang === 'en' ? each?.name : each?.name_ar }}
                      </div>
                      <div class="text-[12px] text-[#C6A798] mb-[8px]">
                        {{ lang === 'en' ? each?.description : each?.description_ar }}
                      </div>
                      <div class="flex justify-start items-start flex-wrap gap-x-[8px] mb-2">
                        <div class="text-[18px] sm:text-[20px] text-[#35474B] font-medium rounded-[10px] px-[10px] py-[2px] cursor-pointer" :class="{'shadow-[0_3px_6px_#80A4A4B2] bg-[#E0E9F0] border border-[#798B97]': item.active, 'bg-[#ffffff] border border-[#798B97]': !item.active}" v-for="(item) in each.values" :key="item.id" @click="changeRadioValue(each.id, item)">
                          {{ lang === 'en' ? item.name : item.name_ar }} <br/>
                          {{ item.price }} {{ lang === 'en' ? 'SAR' : '﷼' }}
                        </div>
                      </div>
                    </div>
                    <div
                        class="shadow-[0_0_8px_0_#E4ECF2] border border-[#E4ECF2] px-[12px] py-[9px] rounded-[20px] mb-[7px]" v-if="each.option_type == 3">
                      <div class="text-[18px] sm:text-[20px] font-medium text-[#35474B]">
                        {{ lang === 'en' ? each?.name : each?.name_ar }}
                      </div>
                      <div class="text-[12px] text-[#C6A798] mb-[8px]">
                        {{ lang === 'en' ? each?.description : each?.description_ar }}
                      </div>
                      <div
                          class="rounded-[10px] w-full bg-[#E0E9F0] px-[17px] pt-[8px] pb-[4px] block sm:flex justify-between items-center mb-[2px]" v-for="(item) in each.values" :key="item.id">
                        <div class="text-[14px] sm:text-[18px] mt-1 mb-3 sm:mb-0 text-[#35474B] uppercase w-[160px]">
                          <div class="truncate-to-1-line">
                            {{ lang === 'en' ? item?.name : item?.name_ar }}
                          </div>
                        </div>
                        <div class="text-[14px] sm:text-[18px] mt-1 mb-3 sm:mb-0 text-[#35474B] sm:text-end">
                          {{item.price}} {{ lang === 'en' ? 'SAR' : '﷼' }}
                        </div>
                        <div class="flex justify-between items-center mb-3 sm:mb-0">
                          <button type="button"
                                  class="w-[25.799px] h-[25.799px] rounded-full border-0 outline-0 flex justify-center items-center !bg-[#3E5463] opacity-50" @click="manageOptionQuantity(2, item)">
                            <svg viewBox="0 0 24 24" style="width:15px;height:15px;" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                              <g id="SVGRepo_iconCarrier">
                                <path
                                    d="M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z"
                                    fill="#ffffff"></path>
                              </g>
                            </svg>
                          </button>
                          <span class="mx-[9px] font-medium"> {{item?.quantity}} </span>
                          <button type="button"
                                  class="w-[25.799px] h-[25.799px] rounded-full border-0 outline-0 flex justify-center items-center !bg-[#3E5463] opacity-50" @click="manageOptionQuantity(1, item)">
                            <svg viewBox="0 0 20 20" style="width:15px;height:15px;" xmlns="http://www.w3.org/2000/svg"
                                 fill="none">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                              <g id="SVGRepo_iconCarrier">
                                <path fill="#ffffff" fill-rule="evenodd"
                                      d="M9 17a1 1 0 102 0v-6h6a1 1 0 100-2h-6V3a1 1 0 10-2 0v6H3a1 1 0 000 2h6v6z"></path>
                              </g>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                        class="shadow-[0_0_8px_0_#E4ECF2] border border-[#E4ECF2] px-[12px] py-[7px] rounded-[20px] mb-[7px]" v-if="each.option_type == 1">
                      <div class="text-[18px] sm:text-[20px] font-medium text-[#35474B]">
                        {{ lang === 'en' ? each.name : each.name_ar }}
                      </div>
                      <div class="text-[12px] text-[#C6A798] mb-[8px]">
                        {{ lang === 'en' ? each.description : each.description_ar }}
                      </div>
                      <template v-if="each?.values?.length > 0">
                        <div
                            class="rounded-[10px] w-full bg-[#E0E9F0] px-[17px] pt-[9px] pb-[4px] block sm:flex justify-between items-center mb-[2px]"
                            v-for="(item) in each.values" :key="item.id">
                          <div class="text-[14px] mb-3 sm:mb-0 sm:text-[18px] text-[#35474B] uppercase w-[180px]">
                            <div class="truncate-to-1-line">
                              {{ lang === 'en' ? item.name : item.name_ar }}
                            </div>
                          </div>
                          <div class="text-[14px] mb-3 sm:mb-0 sm:text-[18px] text-[#35474B] sm:text-end">
                            +{{ item.price }} {{ lang === 'en' ? 'SAR' : '﷼' }}
                          </div>
                          <div class="inline-flex items-center mb-3 sm:mb-0">
                            <label class="flex items-center cursor-pointer relative">
                              <input type="checkbox"
                                     class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-[#798B97] checked:bg-[#798B97] checked:border-[#798B97]"
                                     @change="isChecked($event, item)"/>
                              <span
                                  class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20"
                                       fill="currentColor" stroke="currentColor" stroke-width="1">
                                    <path fill-rule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clip-rule="evenodd"></path>
                                  </svg>
                                </span>
                            </label>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                </template>
                <div class="h-[400px] flex items-center justify-center" v-if="productOptions.length === 0">
                  {{lang == 'en' ? 'No product options found.' : 'لم يتم العثور على خيارات المنتج.'}}
                </div>
              </div>
              <div
                  class="w-full grid grid-cols-1 lg:grid-cols-2 gap-y-3 lg:gap-x-[50px] shadow-[0_0_8px_0_#E4ECF2] pt-[9px] pb-[19px] px-[11px] rounded-[20px_20px_0_0]">
                <div class="col-1">
                  <div
                      class="bg-[#E0E9F0] rounded-[12px] px-[15px] sm:px-[38px] h-[64px] w-full flex justify-between items-center">
                    <button type="button"
                            class="w-[33px] h-[33px] rounded-full border-0 outline-0 flex justify-center items-center !bg-[#35474B] hover:opacity-70 duration-500 opacity-50"
                            @click="manageQuantity(1)">
                      <svg viewBox="0 0 24 24" style="width:35px;height:25px;" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                              d="M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z"
                              fill="#ffffff"></path>
                        </g>
                      </svg>
                    </button>
                    <span class="mx-[9px] font-medium text-[#0C383F] text-[19px] sm:text-[26px]">
                    {{ product?.quantity }}
                  </span>
                    <button type="button"
                            class="w-[33px] h-[33px] rounded-full border-0 outline-0 flex justify-center items-center !bg-[#3E5463] hover:!bg-[#2f3e48] duration-500"
                            @click="manageQuantity(2)">
                      <svg viewBox="0 0 20 20" style="width:35px;height:25px;" xmlns="http://www.w3.org/2000/svg"
                           fill="none">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path fill="#ffffff" fill-rule="evenodd"
                                d="M9 17a1 1 0 102 0v-6h6a1 1 0 100-2h-6V3a1 1 0 10-2 0v6H3a1 1 0 000 2h6v6z"></path>
                        </g>
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="col-1">
                  <button type="button"
                          class="border-0 outline-0 bg-[#C6A798] hover:bg-[#B28F85] duration-500 rounded-[12px] px-[10px] sm:px-[43px] h-[64px] w-full flex justify-center gap-x-[14px] items-center"
                          @click="addBasket"
                          v-if="!basketLoading">
                  <span class="uppercase text-white text-[16px] sm:text-[21px]">
                    {{ lang === 'en' ? 'Add to Order' : 'أضف إلى الطلب' }}
                  </span>
                    <span class="uppercase text-white text-[16px] sm:text-[21px]">
                    {{ product.total_price }} {{ lang === 'en' ? 'SAR' : '﷼' }}
                  </span>
                  </button>
                  <button type="button"
                          class="border-0 outline-0 bg-[#C6A798] hover:bg-[#B28F85] duration-500 rounded-[12px] px-[10px] sm:px-[43px] h-[64px] w-full flex justify-center gap-x-[14px] items-center"
                          :disabled="true"
                          v-if="basketLoading">
                    <span
                        class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                  </button>
                </div>
              </div>
            </div>
            <div class="w-full flex items-center justify-center h-[300px]" v-if="optionLoading">
              <LoaderVue/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AuthModal :authModal="authModal" @handleColse="handleCloseModal" />
</template>

<script>


import LoaderVue from "@/components/Loader.vue";
import ApiService from "@/service/apiService";
import Cookies from "js-cookie";
import {createToaster} from "@meforma/vue-toaster";
import AuthModal from "@/components/AuthModal.vue";

const toaster = createToaster({
  position: 'top-right'
});

export default {
  components: {AuthModal, LoaderVue},
  data() {
    return {
      products: [],
      productOptions: [],
      options: [],
      loading: true,
      optionLoading: false,
      productModal: false,
      product: null,
      basketLoading: false,
      lang: window?.core?.lang,
      authModal: false
    }
  },
  props: {
    branchId: {
      required: true
    },
    categoryId: {
      required: true
    },
    isShorter: {
      required: true
    },
  },
  watch: {
    branchId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getProducts(newValue, this.categoryId);
      }
    },
    categoryId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getProducts(this.branchId, newValue);
      }
    },
    /*    isShorter(newValue, oldValue) {
          if (newValue !== oldValue) {
            this.getProducts(this.branchId, newValue);
          }
        },*/
  },


  methods: {
    async getProducts(branchId = null, categoryId = null) {
      if (this.branchId && this.categoryId) {
        const id = categoryId ? categoryId : this.categoryId;
        const branch_id = branchId ? branchId : this.branchId;
        try {
          this.loading = true;
          const url = `/store/getProductsPerCat`;
          const response = await ApiService.post(url, {id, branch_id});
          this.products = response.data.data;
          this.products.forEach((each, index) => {
            if (index === 0) {
              each.active = true;
            } else {
              each.active = false;
            }
            each.imageUrl = `${process.env.VUE_APP_IMAGE_URL}/${each.image}`;
          })
        } catch (error) {
          this.loading = false;
          console.error("Error fetching users:", error);
        } finally {
          this.loading = false;
        }
      }
    },

    async addBasket() {
      try {
        this.basketLoading = true;
        let userInfo = Cookies.get('user_info');
        if (!userInfo){
          this.authModal = true;
          this.productModal = false;
          return;
        }
        userInfo = JSON.parse(userInfo);
        const url = `/payment/add/basket/item`;
        const data = {
          customer_id: userInfo.client.id,
          product_id: String(this.product.id),
          branch_id: this.branchId,
          price: this.product.price,
          title: this.product.name_en,
          title_ar: this.product.name_ar,
          quantity: String(this.product.quantity),
          delivery: 0,
          image: this.product.image,
          min: 0,
          max: 0,
          options: this.options
        }
        let baskets = localStorage.getItem('baskets');
        if (baskets) {
          baskets = JSON.parse(baskets);
          baskets.forEach(basket => {
            if (basket?.order_details?.product_id == this.product.id) {
              data.order_id = basket.id;
            }
          })
        }
        const response = await ApiService.post(url, data);
        if (response.success) {
          toaster.info(this.lang == 'en' ? 'Basket item has been saved successfully.' : 'تم حفظ عنصر السلة بنجاح.');
          if (baskets) {
            // We will implement this later
            /*const found = baskets.find(each => each.id == response?.data?.data?.id);
            if (!found) {
              const basketCount = document.getElementById('basketCount');
              basketCount.textContent = Number(basketCount.textContent) + 1;

              // Create a new array and update the cookie
              const updatedBaskets = [...baskets, response.data.data];
              localStorage.setItem('baskets', JSON.stringify(updatedBaskets))
            }*/
            const basketCount = document.getElementById('basketCount');
            basketCount.textContent = Number(basketCount.textContent) + 1;
            const updatedBaskets = [...baskets, response.data.data];
            localStorage.setItem('baskets', JSON.stringify(updatedBaskets))
          } else {
            const basketCount = document.getElementById('basketCount');
            basketCount.textContent = Number(basketCount.textContent) + 1;
            localStorage.setItem('baskets', JSON.stringify([response?.data?.data]))
          }
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.basketLoading = false;
      }
    },
    async getOptions(id) {
      try {
        this.optionLoading = true;
        const url = `/store/getProdOptions`;
        const response = await ApiService.post(url, {id});
        this.productOptions = response.data.data;
        this.productOptions.forEach(each => {
          each.values.forEach((el, index) => {
            const item = {...el};
            item.title = item.name;
            item.title_ar = item.name_ar;
            item.quantity = 1;
            delete item['name'];
            delete item['name_ar'];
            if(each.option_type == 2){
              if(index == 0){
                item.active = true;
                this.options.push(item);
              }else {
                item.active = false;
              }
            }
            if(each.option_type == 3){
              this.options.push(item);
            }
          })
        })
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.optionLoading = false;
      }
    },

    manageQuantity(type) {
      if (type == 2) {
        this.product.quantity++;
        this.product.total_price = this.product.quantity * this.product.price;
      }
      if (this.product.quantity > 1 && type == 1) {
        this.product.quantity--;
        this.product.total_price = this.product.quantity * this.product.price;
      }
    },

    async openModal(data) {
      await this.getOptions(data.id);
      this.product = data;
      this.product.total_price = this.product.price;
      this.product.quantity = 1;
      this.productModal = true;
    },

    closeModal() {
      this.productModal = false;
    },

    manageOptionQuantity(type, data) {
      if(type == 2){
        if(data.quantity == 1){
          return;
        }else {
          data.quantity--;
        }
      }else {
        data.quantity++;
      }
    },

    isChecked(e, item) {
      if (e.target.checked) {
        const found = this.options.find(each => each.id == item.id);
        if (!found) {
          this.options.push(item);
        }
      } else {
        this.options = this.options.filter(each => each.id != item.id);
      }
    },

    changeRadioValue(id, data) {
      const option = this.productOptions.find(each => each.id == id);
      option.values.forEach((each) => {
        this.options = this.options.filter(item => item.id != each.id);
        if(each.id === data.id){
          each.active = true;
        }else {
          each.active = false;
        }
      });
    },

    handleCloseModal(){
      this.authModal = false;
    }
  },

  mounted() {
    this.getProducts();
  },
}

</script>